import { Card } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

export const CoverageListSkeleton = () => {
  return (
    <div className="space-y-6">
      {/* Header skeleton */}
      <div className="flex items-center justify-between">
        <Skeleton className="h-7 w-32" />
        <Skeleton className="h-10 w-48" />
      </div>

      {/* Category groups skeleton */}
      {[1, 2].map((group) => (
        <div key={group} className="space-y-3">
          {/* Category header */}
          <div className="flex items-center gap-2">
            <Skeleton className="h-8 w-8 rounded-md" />
            <div className="space-y-1">
              <Skeleton className="h-5 w-24" />
              <Skeleton className="h-3 w-32" />
            </div>
          </div>

          {/* Coverage cards */}
          <div className="space-y-2">
            {[1, 2].map((card) => (
              <Card key={card} className="p-4">
                <div className="flex items-center justify-between">
                  <div className="flex-1 space-y-2">
                    <div className="flex items-center gap-3">
                      <Skeleton className="h-5 w-32" />
                      <Skeleton className="h-5 w-20" />
                    </div>
                    <div className="flex items-center gap-4">
                      <Skeleton className="h-4 w-24" />
                      <Skeleton className="h-4 w-28" />
                    </div>
                    <div className="flex gap-2">
                      <Skeleton className="h-6 w-24 rounded-md" />
                      <Skeleton className="h-6 w-24 rounded-md" />
                    </div>
                  </div>
                  <Skeleton className="h-5 w-5" />
                </div>
              </Card>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
